import { IonFab, IonButton, IonIcon, IonText } from "@ionic/react";
import { addOutline } from "ionicons/icons";

export const CreateFileTemplateButton = () => {
  return (
    <IonFab vertical="bottom" horizontal="end" slot="fixed">
      <IonButton routerLink="/app/tic/plantillas-file/crear" size="large" color="secondary">
        <IonIcon icon={addOutline} slot="start" />
        <IonText>Crear plantilla</IonText>
      </IonButton>
    </IonFab>
  );
};
